var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertYellow = function SvgAlertYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FAA500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06568 12.1162C9.06568 12.7708 8.53506 13.3014 7.8805 13.3014C7.22594 13.3014 6.69531 12.7708 6.69531 12.1162C6.69531 11.4617 7.22594 10.9311 7.8805 10.9311C8.53506 10.9311 9.06568 11.4617 9.06568 12.1162Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69858 3.90693C6.64799 3.21998 7.19168 2.63477 7.88049 2.63477C8.57051 2.63477 9.11463 3.22194 9.06218 3.90997L8.75911 8.92693C8.72385 9.38939 8.33802 9.74647 7.87421 9.74588C7.41041 9.74528 7.0255 9.38721 6.99143 8.92466L6.69858 3.90693Z",
    fill: "#242424"
  })));
};
export default SvgAlertYellow;